<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
    @focus="onFieldFocus"
    @blur="onFieldBlur"
  />
</template>

<script>
import keyboardMixin from '@/mixins/keyboard';

import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldEmail',
  inheritAttrs: false,
  mixins: [keyboardMixin],
  components: {
    BaseField,
  },
  props: {
    invalidValues: {
      type: Array,
      default: () => [],
    },
  },
  staticData: () => ({
    currentLocale: '',
  }),
  computed: {
    attributes() {
      return {
        type: 'email',
        label: this.$t('fields.emailLabel'),
        placeholder: this.$t('fields.emailPlaceholder'),
        errorMessage: this.isValueInvalid
          ? this.$t('fields.emailInvalidError')
          : this.$t('fields.emailError'),
        completeValidator: this.checkIsComplete,
        required: true,
        ...this.$attrs,
      };
    },
    isValueInvalid() {
      return this.invalidValues.includes(this.$attrs.value);
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
    setErrorMessage() {
      return this.$refs.field?.setErrorMessage();
    },
    checkIsComplete(value, field) {
      if (!field.isFieldRequired && value === '') {
        return true;
      }
      if (this.isValueInvalid) {
        return false;
      }
      return /^.+@.+\..+$/.test(value);
    },
    async onFieldFocus() {
      // При фокусе сохраняем текущий язык и переключаем на англ.
      this.currentLocale = await this.getKeyboardLocale();
      this.setEnglishKeyboard();
    },
    onFieldBlur() {
      // При блуре возвращаем язык сохраненный перед фокусом
      this.setKeyboardLocale(this.currentLocale);
    },
  },
};
</script>
